<template>
  <td>
    <a :href="'tel:' + telephoneNumber.telephone_number">
      {{ formatInternationalTelephoneNumber(telephoneNumber.telephone_number) }}
    </a>
    <br />
    <span v-if="telephoneNumber.tps_registered === '1'">
      <span class="label label-negative">TPS Registered</span>
    </span>
  </td>
</template>

<script>
export default {
  methods: {
    formatInternationalTelephoneNumber(s) {
      try {
        const number = window.phoneNumberUtilities.parseAndKeepRawInput(s, '+44');
        return window.phoneNumberUtilities.format(
          number,
          window.phoneNumberFormatter.INTERNATIONAL
        );
      } catch (e) {
        return e;
      }
    },
  },
  name: 'TelephoneNumber',
  props: {
    telephoneNumber: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped></style>
